exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coin_bar{width:100%;height:10px;background-color:#d1cccc}.coin_bar_filled{background-color:#2f3577;display:block;height:10px}.percent24{color:green}.is-{color:red}.landing_portfolio_icon{width:40px!important;height:40px!important;display:inline-block;vertical-align:bottom}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2700f92e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/private/landing/LandingPortfolio.vue
// module id = 849
// module chunks = 2